import { render, staticRenderFns } from "./ProductAttachmentUpload.vue?vue&type=template&id=af0643cc&scoped=true"
import script from "./ProductAttachmentUpload.vue?vue&type=script&lang=js"
export * from "./ProductAttachmentUpload.vue?vue&type=script&lang=js"
import style0 from "./ProductAttachmentUpload.vue?vue&type=style&index=0&id=af0643cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0643cc",
  null
  
)

export default component.exports